module.exports = __webpack_public_path__ + "img/ccdswelcometop.f33c85e5.png";